// extracted by mini-css-extract-plugin
module.exports = {"content":"b3cfa","wrapper":"ba53a","row":"_8b410"};